exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-74f0fc75] {\n  padding: 5px;\n  border-bottom: 1px solid #d4cece;\n}\n.item-sub[data-v-74f0fc75] {\n  margin: 0 0 0 2rem;\n}\n", ""]);

// exports
